import React from 'react';
import { Card } from './SubscriptionAppCard/Card';
import { Badge } from './SubscriptionAppBadge/Badge';
import { Info } from 'lucide-react';
export function SellingPlansPanel() {
  return <div className="flex flex-col gap-6 max-w-5xl mx-auto" data-id="element-4602" data-mp="3fbjzpqkamwoy">
      {/* Selling Plan Groups Card */}
      <Card padding="none" className="border border-[#E2E8F0] overflow-hidden" data-id="element-4603" data-mp="3albwtrp4i4am">
        <div className="p-6 border-b border-[#E2E8F0]" data-id="element-4604" data-mp="3aj90kpxdnexg">
          <div className="flex items-center justify-between mb-2" data-id="element-4605" data-mp="3p8okblyhqk3n">
            <h2 className="text-[16px] font-semibold text-[#0F172A]" data-id="element-4606" data-mp="3kbep1pof7e7w">
              Selling Plan Groups
            </h2>
            <Badge variant="success" data-id="element-4607" data-mp="248oh5ej8gvd">All synced</Badge>
          </div>
          <p className="text-[14px] text-[#64748B]" data-id="element-4608" data-mp="3u9ce2fe3tf1k">
            Each pack size creates one Shopify Selling Plan Group. These are
            auto-generated from your Pack Sizes and Frequencies configuration.
          </p>
        </div>

        <div className="divide-y divide-[#E2E8F0]" data-id="element-4609" data-mp="1zwcz8ohjsovc">
          {/* 3-Pack Row */}
          <div className="p-6 flex items-center justify-between" data-id="element-4610" data-mp="1b9bi4jiogc3g">
            <div className="flex items-start gap-4" data-id="element-4611" data-mp="1g7d3jb3ksni3">
              <div className="w-10 h-10 rounded-lg bg-[#E0F2FE] text-[#0EA5E9] flex items-center justify-center font-semibold text-[16px]" data-id="element-4612" data-mp="1g7wicixxivrw">
                3
              </div>
              <div data-id="element-4613" data-mp="1py7z562pozg7">
                <h3 className="text-[14px] font-semibold text-[#0F172A]" data-id="element-4614" data-mp="1pyr4zof37xdv">
                  3-Pack Taster Box
                </h3>
                <div className="flex items-center gap-2 mt-1 text-[13px] text-[#64748B]" data-id="element-4615" data-mp="1uylv3pr1gixv">
                  <code className="bg-[#F1F5F9] px-1.5 py-0.5 rounded text-[#475569] font-mono text-[12px]" data-id="element-4616" data-mp="1yzxng31ari9r">
                    3pack-taster-box
                  </code>
                  <span data-id="element-4617" data-mp="28vilxr75q0er">· 3 selling plans · Last synced 2 min ago</span>
                </div>
              </div>
            </div>
            <div className="text-right" data-id="element-4618" data-mp="9l9ekbrx0igh">
              <div className="text-[16px] font-semibold text-[#0F172A]" data-id="element-4619" data-mp="eh7xvkydzaa1">18</div>
              <div className="text-[11px] font-medium text-[#94A3B8] uppercase tracking-wider mb-1" data-id="element-4620" data-mp="6h1vms3px6s6">
                PRODUCTS
              </div>
              <Badge variant="success" data-id="element-4621" data-mp="2haze8vf9yg9">Synced</Badge>
            </div>
          </div>

          {/* 6-Pack Row */}
          <div className="p-6 flex items-center justify-between" data-id="element-4622" data-mp="ggsu14veg5xj">
            <div className="flex items-start gap-4" data-id="element-4623" data-mp="bfd5v3xxdjax">
              <div className="w-10 h-10 rounded-lg bg-[#E0F2FE] text-[#0EA5E9] flex items-center justify-center font-semibold text-[16px]" data-id="element-4624" data-mp="pg649zrckyjb">
                6
              </div>
              <div data-id="element-4625" data-mp="lec8o5w0ekq0">
                <h3 className="text-[14px] font-semibold text-[#0F172A]" data-id="element-4626" data-mp="z5zf2yjo19mi">
                  6-Pack Mixed Case
                </h3>
                <div className="flex items-center gap-2 mt-1 text-[13px] text-[#64748B]" data-id="element-4627" data-mp="u6mg5ffisc3k">
                  <code className="bg-[#F1F5F9] px-1.5 py-0.5 rounded text-[#475569] font-mono text-[12px]" data-id="element-4628" data-mp="193nc5v4qut7u">
                    6pack-mixed-case
                  </code>
                  <span data-id="element-4629" data-mp="14391e5brd564">· 3 selling plans · Last synced 2 min ago</span>
                </div>
              </div>
            </div>
            <div className="text-right" data-id="element-4630" data-mp="1rsz3vyzkwtby">
              <div className="text-[16px] font-semibold text-[#0F172A]" data-id="element-4631" data-mp="1rro1o3ls7tmy">24</div>
              <div className="text-[11px] font-medium text-[#94A3B8] uppercase tracking-wider mb-1" data-id="element-4632" data-mp="1drwfvgp0x8ye">
                PRODUCTS
              </div>
              <Badge variant="success" data-id="element-4633" data-mp="1itlqiv8c3kly">Synced</Badge>
            </div>
          </div>

          {/* 12-Pack Row */}
          <div className="p-6 flex items-center justify-between" data-id="element-4634" data-mp="18tcupii98173">
            <div className="flex items-start gap-4" data-id="element-4635" data-mp="18vpjaeiip9t4">
              <div className="w-10 h-10 rounded-lg bg-[#E0F2FE] text-[#0EA5E9] flex items-center justify-center font-semibold text-[16px]" data-id="element-4636" data-mp="v2zobkl0gujv">
                12
              </div>
              <div data-id="element-4637" data-mp="l4aaq405dw9f">
                <h3 className="text-[14px] font-semibold text-[#0F172A]" data-id="element-4638" data-mp="l51y4rjlcnom">
                  12-Pack Cellar Selection
                </h3>
                <div className="flex items-center gap-2 mt-1 text-[13px] text-[#64748B]" data-id="element-4639" data-mp="q2bzn5k98pst">
                  <code className="bg-[#F1F5F9] px-1.5 py-0.5 rounded text-[#475569] font-mono text-[12px]" data-id="element-4640" data-mp="1td7v319rhbqd">
                    12pack-cellar-selection
                  </code>
                  <span data-id="element-4641" data-mp="1jmwqrdm610iy">· 3 selling plans · Last synced 2 min ago</span>
                </div>
              </div>
            </div>
            <div className="text-right" data-id="element-4642" data-mp="1en0lzc5n952c">
              <div className="text-[16px] font-semibold text-[#0F172A]" data-id="element-4643" data-mp="19qjmjlszv49y">24</div>
              <div className="text-[11px] font-medium text-[#94A3B8] uppercase tracking-wider mb-1" data-id="element-4644" data-mp="15ogaauyi3vnm">
                PRODUCTS
              </div>
              <Badge variant="success" data-id="element-4645" data-mp="10q4zagwgzf3t">Synced</Badge>
            </div>
          </div>
        </div>

        <div className="bg-[#F0F9FF] p-4 flex gap-3 border-t border-[#E2E8F0]" data-id="element-4646" data-mp="vrk9lbeugdtm">
          <Info className="w-5 h-5 text-[#0EA5E9] flex-shrink-0 mt-0.5" data-id="element-4647" data-mp="2v3mpkbo9eq2j" />
          <p className="text-[13px] text-[#475569] leading-relaxed" data-id="element-4648" data-mp="2q4a15mhqpaxu">
            Selling plan groups are created and synced automatically when you
            save. Products in each pack size's collection are associated with
            their group. Don't edit these directly in Shopify — changes will be
            overwritten on next sync.
          </p>
        </div>
      </Card>

      {/* Discount Matrix Card */}
      <Card padding="none" className="border border-[#E2E8F0] overflow-hidden" data-id="element-4649" data-mp="3cd8gdo9aa1ti">
        <div className="p-6 border-b border-[#E2E8F0]" data-id="element-4650" data-mp="2eoyh3h0vts63">
          <h2 className="text-[16px] font-semibold text-[#0F172A] mb-2" data-id="element-4651" data-mp="2eqhvt36w3v5r">
            Discount Matrix
          </h2>
          <p className="text-[14px] text-[#64748B]" data-id="element-4652" data-mp="2jq49fdqmrdf3">
            The full grid of selling plans generated from your pack sizes ×
            frequencies. Each cell is one Shopify selling plan.
          </p>
        </div>

        <div className="overflow-x-auto" data-id="element-4653" data-mp="3wvt8our5odq">
          <table className="w-full text-left border-collapse" data-id="element-4654" data-mp="3w3x9cx8tomx">
            <thead data-id="element-4655" data-mp="8vqcfrwmteyd">
              <tr className="bg-[#F8FAFC] border-b border-[#E2E8F0]" data-id="element-4656" data-mp="8v73h0oym0wh">
                <th className="px-6 py-3 text-[11px] font-bold text-[#64748B] uppercase tracking-wider border-r border-[#E2E8F0] w-1/4" data-id="element-4657" data-mp="24z4v0ygiw8fo">
                  Pack Size
                </th>
                <th className="px-6 py-3 text-[11px] font-bold text-[#64748B] uppercase tracking-wider border-r border-[#E2E8F0] text-center w-1/5" data-id="element-4658" data-mp="202eb201lksoz">
                  Monthly
                </th>
                <th className="px-6 py-3 text-[11px] font-bold text-[#64748B] uppercase tracking-wider border-r border-[#E2E8F0] text-center w-1/5" data-id="element-4659" data-mp="29wdcsxxreage">
                  Quarterly
                </th>
                <th className="px-6 py-3 text-[11px] font-bold text-[#64748B] uppercase tracking-wider border-r border-[#E2E8F0] text-center w-1/5" data-id="element-4660" data-mp="1h7pkwjii8mtv">
                  Biannual
                </th>
                <th className="px-6 py-3 text-[11px] font-bold text-[#64748B] uppercase tracking-wider text-center w-[15%]" data-id="element-4661" data-mp="1q8e0hinjqv8v">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#E2E8F0]" data-id="element-4662" data-mp="yh84neeuzjpe">
              {/* Row 1 */}
              <tr data-id="element-4663" data-mp="od19pu7khjkf">
                <td className="px-6 py-4 border-r border-[#E2E8F0]" data-id="element-4664" data-mp="t5ugenmlj1z5">
                  <div className="text-[14px] font-medium text-[#0F172A]" data-id="element-4665" data-mp="t75k6ng1k9q9">
                    3-Pack Taster
                  </div>
                  <div className="text-[13px] text-[#94A3B8]" data-id="element-4666" data-mp="jfrmml7nhjzr">
                    Explorer tier
                  </div>
                </td>
                <td className="px-6 py-4 border-r border-[#E2E8F0] text-center" data-id="element-4667" data-mp="176x04tq4c06w">
                  <div className="text-[14px] font-semibold text-[#0F172A]" data-id="element-4668" data-mp="1c4yh993zhpfq">
                    5% off
                  </div>
                  <code className="text-[11px] text-[#94A3B8] font-mono block mt-1" data-id="element-4669" data-mp="x6wcwwp4ozxf">
                    sp_3p_monthly
                  </code>
                </td>
                <td className="px-6 py-4 border-r border-[#E2E8F0] text-center" data-id="element-4670" data-mp="3hxdoinv60phz">
                  <div className="text-[14px] font-semibold text-[#0F172A]" data-id="element-4671" data-mp="3mwhz9ixqmvaf">
                    10% off
                  </div>
                  <code className="text-[11px] text-[#94A3B8] font-mono block mt-1" data-id="element-4672" data-mp="3478lvra6kfl2">
                    sp_3p_quarterly
                  </code>
                </td>
                <td className="px-6 py-4 border-r border-[#E2E8F0] text-center" data-id="element-4673" data-mp="2u7rixhmbcfss">
                  <div className="text-[14px] font-semibold text-[#0F172A]" data-id="element-4674" data-mp="2u9uiotd9pnap">
                    15% off
                  </div>
                  <code className="text-[11px] text-[#94A3B8] font-mono block mt-1" data-id="element-4675" data-mp="3mx86o1yzn8io">
                    sp_3p_biannual
                  </code>
                </td>
                <td className="px-6 py-4 text-center" data-id="element-4676" data-mp="3hzya82d6lwlc">
                  <Badge variant="success" data-id="element-4677" data-mp="3d5u5lpre20nf">Synced</Badge>
                </td>
              </tr>

              {/* Row 2 */}
              <tr data-id="element-4678" data-mp="3951sumjb5dme">
                <td className="px-6 py-4 border-r border-[#E2E8F0]" data-id="element-4679" data-mp="393h8fpqpjb29">
                  <div className="text-[14px] font-medium text-[#0F172A]" data-id="element-4680" data-mp="9jd7h3b57zqo">
                    6-Pack Mixed
                  </div>
                  <div className="text-[13px] text-[#94A3B8]" data-id="element-4681" data-mp="4p94ev500buv">
                    Enthusiast tier
                  </div>
                </td>
                <td className="px-6 py-4 border-r border-[#E2E8F0] text-center" data-id="element-4682" data-mp="1sdy9ln3q7l7p">
                  <div className="text-[14px] font-semibold text-[#0F172A]" data-id="element-4683" data-mp="1we0b9w9goemz">
                    10% off
                  </div>
                  <code className="text-[11px] text-[#94A3B8] font-mono block mt-1" data-id="element-4684" data-mp="21ee8skdfs66r">
                    sp_6p_monthly
                  </code>
                </td>
                <td className="px-6 py-4 border-r border-[#E2E8F0] text-center" data-id="element-4685" data-mp="2bb97b39pm6l1">
                  <div className="text-[14px] font-semibold text-[#0F172A]" data-id="element-4686" data-mp="2g2hgpzb1hry7">
                    15% off
                  </div>
                  <code className="text-[11px] text-[#94A3B8] font-mono block mt-1" data-id="element-4687" data-mp="2k4cggzdbnx9v">
                    sp_6p_quarterly
                  </code>
                </td>
                <td className="px-6 py-4 border-r border-[#E2E8F0] text-center" data-id="element-4688" data-mp="2u2a3xkncxq1f">
                  <div className="text-[14px] font-semibold text-[#0F172A]" data-id="element-4689" data-mp="2u062raguf54u">
                    18% off
                  </div>
                  <code className="text-[11px] text-[#94A3B8] font-mono block mt-1" data-id="element-4690" data-mp="3um5jpzue4grr">
                    sp_6p_biannual
                  </code>
                </td>
                <td className="px-6 py-4 text-center" data-id="element-4691" data-mp="2hbbxq5pmjg6">
                  <Badge variant="success" data-id="element-4692" data-mp="79kyqxbj33e8">Synced</Badge>
                </td>
              </tr>

              {/* Row 3 */}
              <tr data-id="element-4693" data-mp="c7wbbft7js05">
                <td className="px-6 py-4 border-r border-[#E2E8F0]" data-id="element-4694" data-mp="caiihec6s5hu">
                  <div className="text-[14px] font-medium text-[#0F172A]" data-id="element-4695" data-mp="h67kdobohyhb">
                    12-Pack Cellar
                  </div>
                  <div className="text-[13px] text-[#94A3B8]" data-id="element-4696" data-mp="m4hjub4frl8q">
                    Collector tier
                  </div>
                </td>
                <td className="px-6 py-4 border-r border-[#E2E8F0] text-center" data-id="element-4697" data-mp="2nyqi0b7b3tmw">
                  <div className="text-[14px] font-semibold text-[#0F172A]" data-id="element-4698" data-mp="2rzad798bkn6e">
                    15% off
                  </div>
                  <code className="text-[11px] text-[#94A3B8] font-mono block mt-1" data-id="element-4699" data-mp="2kh2rql1xh5gh">
                    sp_12p_monthly
                  </code>
                </td>
                <td className="px-6 py-4 border-r border-[#E2E8F0] text-center" data-id="element-4700" data-mp="2apyepqvtbuoa">
                  <div className="text-[14px] font-semibold text-[#0F172A]" data-id="element-4701" data-mp="2anve6cx1aj5b">
                    18% off
                  </div>
                  <code className="text-[11px] text-[#94A3B8] font-mono block mt-1" data-id="element-4702" data-mp="33ff40fo4yvga">
                    sp_12p_quarterly
                  </code>
                </td>
                <td className="px-6 py-4 border-r border-[#E2E8F0] text-center" data-id="element-4703" data-mp="2ydzhej6b8gvs">
                  <div className="text-[14px] font-semibold text-[#0F172A]" data-id="element-4704" data-mp="2ucdyoh73h8do">
                    20% off
                  </div>
                  <code className="text-[11px] text-[#94A3B8] font-mono block mt-1" data-id="element-4705" data-mp="1iz230tlhnw2l">
                    sp_12p_biannual
                  </code>
                </td>
                <td className="px-6 py-4 text-center" data-id="element-4706" data-mp="1dynr30gro1za">
                  <Badge variant="success" data-id="element-4707" data-mp="1fgmchfbkilzk">Synced</Badge>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Card>

      {/* Product Associations Card */}
      <Card padding="none" className="border border-[#E2E8F0] overflow-hidden" data-id="element-4708" data-mp="16gzdf06b9s9o">
        <div className="p-6 border-b border-[#E2E8F0]" data-id="element-4709" data-mp="1ai1hbub6ashz">
          <h2 className="text-[16px] font-semibold text-[#0F172A] mb-2" data-id="element-4710" data-mp="1aggk1wxh4vgf">
            Product Associations
          </h2>
          <p className="text-[14px] text-[#64748B]" data-id="element-4711" data-mp="wojxs9ihlfry">
            Which Shopify collections are linked to each selling plan group, and
            how many products have the plans attached.
          </p>
        </div>

        <div className="overflow-x-auto" data-id="element-4712" data-mp="rrjqjv9wi6z9">
          <table className="w-full text-left border-collapse" data-id="element-4713" data-mp="rsbkz2rrhyny">
            <thead data-id="element-4714" data-mp="ds0u3zqgck2s">
              <tr className="bg-[#F8FAFC] border-b border-[#E2E8F0]" data-id="element-4715" data-mp="drio4bdzmrho">
                <th className="px-6 py-3 text-[11px] font-bold text-[#64748B] uppercase tracking-wider w-1/3" data-id="element-4716" data-mp="iqvidh76v0ua">
                  Collection
                </th>
                <th className="px-6 py-3 text-[11px] font-bold text-[#64748B] uppercase tracking-wider text-center w-1/4" data-id="element-4717" data-mp="3vapwt3e2ktqf">
                  Selling Plan Group
                </th>
                <th className="px-6 py-3 text-[11px] font-bold text-[#64748B] uppercase tracking-wider text-center w-1/4" data-id="element-4718" data-mp="86jhzkx6hnbp">
                  Products
                </th>
                <th className="px-6 py-3 text-[11px] font-bold text-[#64748B] uppercase tracking-wider text-center w-[15%]" data-id="element-4719" data-mp="i3ec7rmf51k6">
                  Status
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#E2E8F0]" data-id="element-4720" data-mp="ru0p3e2r3dz6">
              <tr data-id="element-4721" data-mp="rvk30y0xpcxs">
                <td className="px-6 py-4" data-id="element-4722" data-mp="muwgopnnhk9w">
                  <div className="text-[14px] font-medium text-[#0F172A]" data-id="element-4723" data-mp="mv672eclxtg4">
                    Club Reds — Taster Range
                  </div>
                </td>
                <td className="px-6 py-4 text-center" data-id="element-4724" data-mp="vvukp7y39rsh">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded text-xs font-medium bg-[#F0F9FF] text-[#0284C7] border border-[#E0F2FE]" data-id="element-4725" data-mp="vt9haei573sm">
                    3-Pack Taster Box
                  </span>
                </td>
                <td className="px-6 py-4 text-center text-[14px] text-[#64748B]" data-id="element-4726" data-mp="300uezhrnd8qu">
                  18 of 18 linked
                </td>
                <td className="px-6 py-4 text-center" data-id="element-4727" data-mp="342fyvn2lmnaj">
                  <Badge variant="success" data-id="element-4728" data-mp="27cykmjpjvsx8">Synced</Badge>
                </td>
              </tr>
              <tr data-id="element-4729" data-mp="2cbi7cmbyx8qn">
                <td className="px-6 py-4" data-id="element-4730" data-mp="2cb0435qw1u98">
                  <div className="text-[14px] font-medium text-[#0F172A]" data-id="element-4731" data-mp="2cc1o3zpvtr33">
                    Club Mixed — Full Range
                  </div>
                </td>
                <td className="px-6 py-4 text-center" data-id="element-4732" data-mp="2ldj2ndnn5kpo">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded text-xs font-medium bg-[#F0F9FF] text-[#0284C7] border border-[#E0F2FE]" data-id="element-4733" data-mp="3rsk23tbvkl10">
                    6-Pack Mixed Case
                  </span>
                </td>
                <td className="px-6 py-4 text-center text-[14px] text-[#64748B]" data-id="element-4734" data-mp="ap4eyfvpag5l">
                  24 of 24 linked
                </td>
                <td className="px-6 py-4 text-center" data-id="element-4735" data-mp="5ruqb2g4y8it">
                  <Badge variant="success" data-id="element-4736" data-mp="zku54ofgc83">Synced</Badge>
                </td>
              </tr>
              <tr data-id="element-4737" data-mp="3t4yiorr0urw4">
                <td className="px-6 py-4" data-id="element-4738" data-mp="3t3dnczwvv4x7">
                  <div className="text-[14px] font-medium text-[#0F172A]" data-id="element-4739" data-mp="3t2c9knohg4bs">
                    Club Premium — Cellar Range
                  </div>
                </td>
                <td className="px-6 py-4 text-center" data-id="element-4740" data-mp="3j4eephc4b9a7">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded text-xs font-medium bg-[#F0F9FF] text-[#0284C7] border border-[#E0F2FE]" data-id="element-4741" data-mp="3e6ctoqv4szw3">
                    12-Pack Cellar Selection
                  </span>
                </td>
                <td className="px-6 py-4 text-center text-[14px] text-[#64748B]" data-id="element-4742" data-mp="1ceztug80ti6w">
                  22 of 24 linked
                </td>
                <td className="px-6 py-4 text-center" data-id="element-4743" data-mp="31wn8tj2d7pnb">
                  <Badge variant="warning" data-id="element-4744" data-mp="31v3s5rcsrcl0">2 pending</Badge>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="bg-[#F0F9FF] p-4 flex gap-3 border-t border-[#E2E8F0]" data-id="element-4745" data-mp="2sw8j87idboe0">
          <Info className="w-5 h-5 text-[#0EA5E9] flex-shrink-0 mt-0.5" data-id="element-4746" data-mp="2su5lf1az4qyq" />
          <p className="text-[13px] text-[#475569] leading-relaxed" data-id="element-4747" data-mp="2wxtslivp1kjg">
            When products are added to or removed from a collection, we
            automatically add or remove the selling plan association on next
            sync. 2 products in "Club Premium" were recently added and will be
            linked on the next sync cycle.
          </p>
        </div>
      </Card>
    </div>;
}